module.exports = __webpack_public_path__ + "static/media/Uniqlomap.1a4eebbf.png";